// extracted by mini-css-extract-plugin
export default {"mainText":"pd3VGHYC5ceoplhRtccQ"};